<script lang="ts">
  interface Props {
    value?: 'Beta' | 'Prod';
    onchange?: (env: 'Beta' | 'Prod') => void;
  }

  let { value = $bindable('Beta'), onchange }: Props = $props();

  function select(env: 'Beta' | 'Prod') {
    value = env;
    onchange?.(env);
  }
</script>

<div class="flex items-center bg-bg-input border border-border rounded-full p-0.5" role="radiogroup" aria-label="Environment">
  <button
    onclick={() => select('Beta')}
    class="px-4 py-1.5 rounded-full text-xs font-medium transition-all {value === 'Beta' ? 'bg-accent text-white shadow-lg shadow-accent/25' : 'text-text-secondary hover:text-text-primary'}"
    role="radio"
    aria-checked={value === 'Beta'}
  >
    Beta
  </button>
  <button
    onclick={() => select('Prod')}
    class="px-4 py-1.5 rounded-full text-xs font-medium transition-all {value === 'Prod' ? 'bg-error text-white shadow-lg shadow-error/25' : 'text-text-secondary hover:text-text-primary'}"
    role="radio"
    aria-checked={value === 'Prod'}
  >
    Prod
  </button>
</div>
